import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';
import styles from './index.module.scss';
import Button from 'components/Button';
import InputLabel from '@material-ui/core/InputLabel';

import { eventStatusValue as eventStatus } from 'utils/constants/eventStatus';
import { eventsPageActions } from '../';

const ApproveOrRejectEvent = ({
  eventId,
  status,
  approver,
  approveEvent,
  rejectEvent,
}) => {
  const onClickApprove = () => {
    approveEvent(approver, eventId);
  };

  const onClickReject = () => {
    rejectEvent(approver, eventId);
  };
  return (
    <div className={cn(styles.operationalView, styles.btnWithLabel)}>
      <InputLabel>Approve/Reject:</InputLabel>
      <div>
        <Button
          text="REJECT"
          className={styles.button}
          color={'secondary'}
          onClick={onClickReject}
          outline={true}
        />

        <Button
          disabled={status === eventStatus.PUBLISHED}
          text="APPROVE"
          className={styles.button}
          color={'primary'}
          onClick={onClickApprove}
        />
      </div>
    </div>
  );
};

ApproveOrRejectEvent.propTypes = {
  status: PropTypes.string,
  eventId: PropTypes.string,
  approver: PropTypes.object,
  rejectEvent: PropTypes.func,
  approveEvent: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  approveEvent: (approver, id) =>
    dispatch(eventsPageActions.approveEvent({ approver, id })),
  rejectEvent: (approver, id) =>
    dispatch(eventsPageActions.rejectEvent({ approver, id })),
});

export default connect(null, mapDispatchToProps)(ApproveOrRejectEvent);
